module.exports = __webpack_public_path__ + "img/logo-cinza.9727c77f.png";